import _ from 'lodash';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import BgBlink from 'common/components/BgBlink/index';
import MoneyDisplay from 'common/components/MoneyDisplay';
import TransactionType from 'common/components/TransactionType';
import ForceExitConfirmation from 'common/components/ForceExitConfirmation/index';
import { pairedPropTypes } from './pairedPropTypes';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import OrderStatusWithMessage from 'v3/common/components/OrderStatusWithMessage';

const propTypes = {
  pairedOrder: pairedPropTypes,
  priceData: PropTypes.number,
  onForceExit: PropTypes.func.isRequired,
  isShowIndividualSquareOff: PropTypes.bool.isRequired
};

const defaultProps = { pairedOrder: {}, priceData: null };

const { isCrypto } = ApplicationDomainUtility;

const TableLegRow = ({
  pairedOrder, priceData, onForceExit, isShowIndividualSquareOff
}) => {
  const {
    entryType, exitType, orderProfit, quantity, entryPrice, exitPrice,
    tradingSymbol, shouldCalculateUnrealizedProfit, isManualExitShow, caseIndex,
    entryOrderStatus, exitOrderStatus, entryOrder, exitOrder
  } = pairedOrder;

  const renderPrice = (price) => {
    if (!_.isNumber(price) || price === 0) return '-';

    return <MoneyDisplay shouldColor>{price}</MoneyDisplay>;
  };

  const parseCryptoTradingSymbol = (symbol) => {
    if (_.endsWith(symbol, 'FUT'))
      return symbol.replace(/\d{2}[A-Z]{3}\d{2}(?=FUT$)/, " PERPETUAL");

    return symbol;
  }

  return (
    <tr>
      <td>{_.toNumber(caseIndex) + 1}</td>
      <td>{isCrypto ? parseCryptoTradingSymbol(tradingSymbol) : tradingSymbol}</td>
      <td>{quantity}</td>
      <td>
        <div className="entry d-flex align-items-center gap-15">
          <TransactionType type={entryType} />
          <div className="price">{renderPrice(entryPrice)}</div>
        </div>
        <OrderStatusWithMessage status={entryOrderStatus} order={entryOrder} className="tx-10" />
      </td>
      <td>
        <div className="entry d-flex align-items-center gap-15">
          <TransactionType type={exitType} />
          <div className="price">{renderPrice(exitPrice)}</div>
        </div>
        <OrderStatusWithMessage status={exitOrderStatus} order={exitOrder} className="tx-10" />
      </td>
      <td>{(shouldCalculateUnrealizedProfit && priceData) ? <BgBlink>{priceData}</BgBlink> : '-'}</td>
      <td>{renderPrice(orderProfit)}</td>
      <td>
        {(isManualExitShow && isShowIndividualSquareOff)
          && <ForceExitConfirmation onForceExit={onForceExit} label="Close position" />}
      </td>
    </tr>
  );
};

TableLegRow.propTypes = propTypes;
TableLegRow.defaultProps = defaultProps;

export default memo(TableLegRow);
